// reviews 模块的 Vuex store
import api from '@/api/axios'
import { calculateNextReview } from '@/utils/sm2'
import { ElMessage } from 'element-plus'

export default {
  namespaced: true,
  state: {
    // 在这里定义您的状态
    reviews: [],
    history: [],
    settings: {
      initialInterval: 1,
      dailyLimit: 20,
      intervalModifier: 1.0
    },
    continuousReviewDays: 0,
    loading: false,
    error: null,
    reviewCount: 0,
    todayReviews: [], // 初始化空数组
    completedCount: 0, // 今日已完成数量
    todayReviewsCount: 0, // 总待复习数量
    privateNotesCount: 0, // 私人笔记待复习数量
    ankiCardsCount: 0 // Anki闪卡待复习数量
  },
  mutations: {
    // 在这里定义您的 mutations
    SET_REVIEWS(state, reviews) {
      state.reviews = reviews;
    },
    SET_REVIEW_COUNT(state, count) {
      console.log(count)
      state.reviewCount = count;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
    SET_TODAY_REVIEWS(state, reviews) {
      state.todayReviews = reviews
    },
    SET_HISTORY(state, history) {
      state.history = history
    },
    SET_SETTINGS(state, settings) {
      state.settings = settings
    },
    SET_CONTINUOUS_DAYS(state, days) {
      state.continuousReviewDays = days
    },
    SET_COMPLETED_COUNT(state, count) {
      state.completedCount = count
    },
    UPDATE_REVIEW(state, { noteId, review }) {
      const index = state.reviews.findIndex(r => r.noteId === noteId)
      if (index !== -1) {
        state.reviews[index] = { ...state.reviews[index], ...review }
      }
    },
    SET_TODAY_REVIEWS_COUNT(state, count) {
      state.todayReviewsCount = count
    },
    SET_PRIVATE_NOTES_COUNT(state, count) {
      state.privateNotesCount = count
    },
    SET_ANKI_CARDS_COUNT(state, count) {
      state.ankiCardsCount = count
    },
  },
  actions: {
    async markReviewComplete(_, { reviewId }) {
      return api.patch(`/reviews/${reviewId}`, {
        completed: true
      })
    },
    async doReview(_, { record_id, level }) {
      return api.post(`/reviews/doReview`, {
        record_id: record_id,
        level: level
      })
    },
    async fetchSettings({ commit }) {
      try {
        const response = await api.get('/reviews/settings')
        if (response.data.status === 200) {
          commit('SET_SETTINGS', response.data.data)
        }
      } catch (error) {
        console.error('获取设置失败:', error)
      }
    },
    async updateSettings({ commit }, settings) {
      try {
        const response = await api.post('/reviews/settings', settings)
        if (response.data.status === 200) {
          commit('SET_SETTINGS', settings)
        }
      } catch (error) {
        console.error('更新设置失败:', error)
      }
    },
    async recordReview({ commit, state }, { noteId, quality }) {
      try {
        const review = state.reviews.find(r => r.noteId === noteId)
        if (!review) return
        
        const nextReview = calculateNextReview(review, quality, state.settings)
        
        const response = await api.post('/reviews/record', {
          noteId,
          quality,
          nextReview
        })
        
        if (response.data.status === 200) {
          commit('UPDATE_REVIEW', {
            noteId,
            review: {
              lastReview: new Date().toISOString(),
              nextReview,
              quality,
              completed: true
            }
          })
        }
      } catch (error) {
        console.error('记录复习失败:', error)
      }
    },
    async fetchTodayReviewsCount({ commit }) {
      commit('SET_LOADING', true)
      try {
        const response_today = await api.get('/records/nowReviewCount')
        if (response_today.data.status === 200) {
          // 根据新的API响应结构处理数据
          // anki_count: Anki闪卡待复习数量
          // record_count: 私人笔记待复习数量  
          // count: 二者加和的总数量
          const { anki_count = 0, record_count = 0, count = 0 } = response_today.data.data || {}
          
          commit('SET_ANKI_CARDS_COUNT', anki_count)
          commit('SET_PRIVATE_NOTES_COUNT', record_count)
          commit('SET_TODAY_REVIEWS_COUNT', count) // 保持向后兼容
          commit('SET_COMPLETED_COUNT', 0) // 根据实际API调整
          commit('SET_CONTINUOUS_DAYS', 0) // 根据实际API调整
        }
      } catch (error) {
        console.error('获取复习数据失败:', error)
        ElMessage.error('获取复习数据失败')
      } finally {
        commit('SET_LOADING', false)
      }
    },
    async fetchTodayReviews({ commit }) {
      commit('SET_LOADING', true)
      try {
        const response_today = await api.get('/records/nowReview')
        commit('SET_TODAY_REVIEWS', response_today.data.data)
        // commit('SET_COMPLETED_COUNT', response.data.data.completedCount)
        // commit('SET_CONTINUOUS_DAYS', response.data.data.continuousReviewDays)
      } catch (error) {
        console.error('获取复习数据失败:', error)
        ElMessage.error('获取复习数据失败')
      } finally {
        commit('SET_LOADING', false)
      }
    }
  },
  getters: {
    // 在这里定义您的 getters
    getReviews: state => state.reviews,
    todayReviews: state => state.todayReviews,
    getTodayReviews: (state) => {
      return state.todayReviews
    },
    getTodayCompletedCount: (state) => {
      return state.completedCount
    },
    getEfficiencyData: (state) => {
      // 计算最近7天的记忆效率数据
      const days = 7
      const data = []
      const today = new Date()
      
      for (let i = 0; i < days; i++) {
        const date = new Date(today)
        date.setDate(date.getDate() - i)
        date.setHours(0, 0, 0, 0)
        
        const dayReviews = state.history.filter(review => {
          const reviewDate = new Date(review.date)
          return reviewDate >= date && reviewDate < new Date(date.getTime() + 86400000)
        })
        
        const totalReviews = dayReviews.length
        const goodReviews = dayReviews.filter(r => r.quality >= 3).length
        
        data.unshift({
          date: date.toISOString().split('T')[0],
          efficiency: totalReviews ? (goodReviews / totalReviews * 100).toFixed(1) : 0
        })
      }
      
      return data
    }
  }
};